import type { BillingOverview } from 'types/billing';
import api, { API_HOST } from 'helpers/api';

export const fetchBillingOverview = () => api.get<BillingOverview>('/billing/overview');
export const cancelSubscription = () => api.post('/billing/subscription/cancel') as Promise<void>;
export const redirectToCheckout = () => {
  window.location.href = `${API_HOST}/billing/subscription/checkout`;
}
